module.exports = __webpack_public_path__ + "img/mission.6e0b4716.svg";